<template>
<div class="map-automap-device-table">
  <el-tooltip content="연결정보 숨기기" placement="top">
    <div class="map-automap-device-table-collapse" @click="visible(false)">
      <!-- style 추가 191219 sohong-->
      <i class="far fa-chevron-down"></i>
    </div>
  </el-tooltip>
  <el-row type="flex" justify="space-between" class="title-bar vertical-center-box">
    <div class="vertical-center-box">
      <div class="title-h3">연결장비 목록</div>
      <!-- <el-radio-group class="tree-type-radio" v-model="activeType">
        <el-radio-button label="device"><span>연결장비 목록</span></el-radio-button>
        <el-radio-button label="hist"><span>변경이력</span></el-radio-button>
      </el-radio-group> -->
    </div>
    <div class="vertical-center-box">
      <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
    </div>
  </el-row>
  <el-row style="height: calc(100% - 31px)">
    <el-table-wrapper
      v-loading="isLoading"
      height="100%"
      style="width: 100%; height: 100%"
      ref="automapDeviceTable"
      border
      header-align="center"
      :data="tableData"
      :columns="tableColumns"
      :pagination="false"
      :show-custom-header="true"
      :show-search-tool="showSearchTool">
      <template slot-scope="scope" slot="obj-name-slot">
        <span class="link c-pointer" @click="onClickObjName(scope.row)">{{scope.row.objName}}</span>
      </template>
      <template slot-scope="scope" slot="device-status-slot">
        <span :style="deviceStatusColor(scope.row)">{{getDeviceStatusLabel(scope.row, scope.column.property)}}</span>
      </template>
    </el-table-wrapper>
  </el-row>
</div>
</template>

<script>
import Base from '@/mixins/topologymap/base';
import MapAPI from '@/api/topologymap/common';
import MapConst from '@/constants/topologymap';

import { MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WMapAutomapDeviceTable',
  mixins: [Base],
  components: {
  },
  data() {
    return {
      activeType: 'device',
      isLoading: false,
      showSearchTool: false,
      tableData: [],
      tableColumns: [
        {
          prop: 'deviceStatus',
          scopedSlot: 'device-status-slot',
          label: '장비상태',
          width: 80,
          headerAlign: 'center',
          sortable: true,
          filters: [{
            text: '신규',
            value: 'N',
          }, {
            text: '삭제',
            value: 'D',
          }, {
            text: '미변경',
            value: 'X',
          }],
        },
        {
          prop: 'objName',
          label: '장비명',
          // width: 110,
          headerAlign: 'center',
          searchable: true,
          sortable: true,
          scopedSlot: 'obj-name-slot',
        },
        {
          prop: 'ipaddress',
          label: 'IP',
          width: 120,
          headerAlign: 'center',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'macAddress',
          label: 'MAC',
          width: 130,
          headerAlign: 'center',
          searchable: true,
          sortable: true,
        },
        // {
        //   prop: 'location',
        //   label: '위치',
        //   // width: 100,
        //   headerAlign: 'center',
        //   searchable: true,
        // },
        {
          prop: 'objtypeName',
          label: '장비종류',
          width: 120,
          headerAlign: 'center',
          searchable: true,
          sortable: true,
        },
        // {
        //   prop: 'model',
        //   label: 'OS/모델명',
        //   // width: 100,
        //   headerAlign: 'center',
        //   searchable: true,
        // },
        {
          prop: 'objCompanyName',
          label: '제조사',
          // width: 100,
          headerAlign: 'center',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'deviceDesc',
          label: '설명',
          // width: 100,
          headerAlign: 'center',
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  watch: {
    /**
     * 보이기/숨기기 상태가 변경되면 호출
     * @author KangBongHun(toto1323)
     * @param  {[type]}  value [description]
     * @return {Boolean}       [description]
     */
    isAutomapDeviceTableExpand(visible) {
      if (visible === true) {
        this.loadData();
      } else {
        this.tableData = [];
        this.activeType = 'device';
        this.showSearchTool = false;

        if (this.$refs.automapDeviceTable) {
          this.$refs.automapDeviceTable.clearFilter();
        }
      }

      this.$nextTick(() => {
        const graph = MapInfo.getInstance(this).getGraph();
        const canvas = MapInfo.getInstance(this).getCanvas();

        if (graph && canvas) {
          graph.updateViewport();
          canvas.updateZoom();
        }
      });
    },
  },
  created() {
  },
  mounted() {
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.AUTOMAP_DEVICE_VISIBLE, this.visible);
  },
  beforeDestroy() {
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.AUTOMAP_DEVICE_VISIBLE, this.visible);
  },
  methods: {
    visible(value) {
      this.$store.commit('setAutomapDeviceTableExpand', value);
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    loadData() {
      this.isLoading = true;
      const tableParams = this.$refs.automapDeviceTable.getParameter();
      const params = {
        ...tableParams,
        mapId: this.currentMapId,
      };
      MapAPI.getAutomapDeviceList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
        } else {
          this.tableData = [];
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getDeviceStatusLabel(row, props) {
      let returnValue = '';
      if (row[props] === 'N') {
        returnValue = '신규';
      } else if (row[props] === 'D') {
        returnValue = '삭제';
      } else {
        returnValue = '미변경';
      }
      return returnValue;
    },
    deviceStatusColor(row) {
      if (row.deviceStatus === 'N' || row.deviceStatus === 'D') {
        return {
          color: (row.deviceStatus === 'N' ? '#1E7EFA' : '#F23F5C'),
        };
      }
      return null;
    },
    onClickObjName(row) {
      const canvas = MapInfo.getInstance(this).getCanvas();
      const graph = MapInfo.getInstance(this).getGraph();

      if (canvas) {
        canvas.initSelect(graph, {
          ipaddress: row.ipaddress,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.map-automap-device-table {
  width: 100%;
  height: 100%;
  padding: 10px;
  position: relative;
}
.map-automap-device-table-collapse {
  width: 50px;
  height: 18px;
  position: absolute;
  top: -18px;
  right: calc(50% - 25px);
  color: #8a8a8a;
  background: white;
  line-height: 20px;
  text-align: center;
  border: 1px solid #ddd;
  border-bottom: none;
  box-shadow: -1px 0 2px 0 rgba(0, 0, 0, 0.07);
  cursor: pointer;
  border-radius: 6px 6px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MapAutomapDeviceTable.vue